import { TableBody } from '@client/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
// import { mockBuildings } from '../mockData';
import { Tenant } from '../../types';
import { BuildingRow } from './building-row';
import { TenantRow } from './tenant-row';
import { BuildingAccountsReceivableDto, TenantAccountsReceivableDto } from '@client/api';

export const InvoicesTable: React.FC<{
  data: BuildingAccountsReceivableDto[];
  selectedYear: string;
  comparisonYear: string;
  isLoading: boolean;
  onSelected: (ids: Set<string>) => void;
}> = ({ data, selectedYear, comparisonYear, isLoading, onSelected }) => {
  const { t } = useTranslation('reporting');

  const columns = [
    { key: 'name', label: t('invoices.building') },
    { key: 'localsCount', label: t('invoices.tenants') },
    { key: 'outstandingSelectedPeriod', label: t('invoices.outstandingSelectedPeriod', { period: selectedYear }) },
    {
      key: 'outstandingComparisonPeriod',
      label: t('invoices.outstandingComparisonPeriod', { period: comparisonYear }),
    },
    { key: 'invoicesAmount', label: t('invoices.invoices') },
    { key: 'invoicesDes', label: t('invoices.invoicesDes') },
    { key: 'dueDate', label: t('invoices.dueDate') },
  ];
  return (
    <ExpanableTableWraper
      loading={isLoading}
      columns={columns}
      data={data}
      onSelected={onSelected}
      renderBody={(
        data,
        selectedRows,
        expandedRows,
        handleToggleSelect,
        handleKeyDownSelect,
        handleToggleExpand,
        handleKeyDownExpand,
      ) => (
        <TableBody>
          {data.map((building) => (
            <React.Fragment key={building.buildingId}>
              <BuildingRow
                building={building}
                selectedRows={selectedRows}
                handleToggleSelect={handleToggleSelect}
                handleKeyDownSelect={handleKeyDownSelect}
                handleToggleExpand={handleToggleExpand}
                handleKeyDownExpand={handleKeyDownExpand}
                expandedRows={expandedRows}
              />
              {expandedRows.has(building.buildingId) &&
                building.tenantReceivables.map((tenant: TenantAccountsReceivableDto) => (
                  <TenantRow
                    key={tenant.tenantId}
                    tenant={tenant}
                    handleToggleExpand={handleToggleExpand}
                    handleKeyDownExpand={handleKeyDownExpand}
                    expandedRows={expandedRows}
                  />
                ))}
            </React.Fragment>
          ))}
        </TableBody>
      )}
    />
  );
};
